import { Text, Center, Image, Box } from "@chakra-ui/react";
import howItWorksVisual from "../images/howItWorksVisual.png";

export default function HowItWorks(props) {
  return (
    <div {...props} style={{ paddingTop: "80px" }}>
      <Box mt='10px'>
        <Center>
          <Text
            color='white'
            fontSize={{ base: "xl", md: "2xl", lg: "4xl" }}
            fontWeight={700}
          >
            How It Works
          </Text>
        </Center>
        <Center>
          <Image
            src={howItWorksVisual}
            alt='a-visual-representation-of-how-hypospadias-ai-works'
            width={{ base: "100%", md: "77%", lg: "77%" }}
            borderRadius={3}
          />
        </Center>
      </Box>
    </div>
  );
}
